import React from "react";
import css from "./LiveManager.module.scss";
import useSession from "@/template/live/useSession";
import useQuestion from "@/template/live/useQuestion";

const LiveManager = () => {
  const { activeSessionId, sessionStatus, activeSessionObj } = useSession();
  const { activeQuiz } = useQuestion(activeSessionId[0]);

  return null;
};

export default LiveManager;
